// The full-page message a client tab shows when it is not showing the app
// (#10718): a spent link, access ended. A client tab has no sign-in
// of its own; its only credential is a grant, and the way out is home.
import React from "react";
import { ShieldCheck } from "@phosphor-icons/react";
import { goHome } from "@/services/clientEnvironment";

interface ClientEnvironmentNoticeProps {
  title: string;
  children?: React.ReactNode;
  /** Actions shown before the way home (the ended page's Reopen). */
  actions?: React.ReactNode;
  /** Returns this tab to home; replaced in stories. */
  onHome?: () => void;
}

const ClientEnvironmentNotice: React.FC<ClientEnvironmentNoticeProps> = ({
  title,
  children,
  actions = null,
  onHome = goHome,
}) => (
  <main className="min-h-[100dvh] w-full flex items-center justify-center bg-white px-4">
    <div className="w-full max-w-md rounded-[10px] border border-gray-200 p-6 flex flex-col gap-3">
      <div className="flex items-center gap-2 text-[#0B5F5A]">
        <ShieldCheck className="w-5 h-5 flex-shrink-0" weight="fill" />
        <span className="text-xs font-medium uppercase tracking-wide">
          Client environment
        </span>
      </div>
      <h1 className="text-lg font-semibold text-[#10141B] break-words">
        {title}
      </h1>
      {children && (
        <p className="text-sm text-[#6E7480] break-words">{children}</p>
      )}
      <div className="flex flex-wrap gap-2">
        {actions}
        <button
          type="button"
          onClick={() => onHome()}
          className="text-sm px-3 py-2 rounded-md border border-gray-300 text-gray-800 hover:bg-gray-50 cursor-pointer"
        >
          Go to Finpilot
        </button>
      </div>
    </div>
  </main>
);

export default ClientEnvironmentNotice;
